module.exports = __webpack_public_path__ + "static/media/27OCHA19.2612dacf.jpg";